import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaste = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.66675 21C4.19442 21 3.79858 20.8403 3.47925 20.5208C3.15975 20.2014 3 19.8056 3 19.3333V4.66675C3 4.19442 3.15975 3.79858 3.47925 3.47925C3.79858 3.15975 4.19442 3 4.66675 3H9.425C9.56383 2.41667 9.87492 1.9375 10.3582 1.5625C10.8416 1.1875 11.3888 1 12 1C12.6222 1 13.1736 1.1875 13.6543 1.5625C14.1347 1.9375 14.4444 2.41667 14.5833 3H19.3333C19.8056 3 20.2014 3.15975 20.5208 3.47925C20.8403 3.79858 21 4.19442 21 4.66675V19.3333C21 19.8056 20.8403 20.2014 20.5208 20.5208C20.2014 20.8403 19.8056 21 19.3333 21H4.66675ZM4.66675 19.3333H19.3333V4.66675H17.6667V7.16675H6.33325V4.66675H4.66675V19.3333ZM12 4.66675C12.2833 4.66675 12.5208 4.57092 12.7125 4.37925C12.9042 4.18758 13 3.95008 13 3.66675C13 3.38342 12.9042 3.14592 12.7125 2.95425C12.5208 2.76258 12.2833 2.66675 12 2.66675C11.7167 2.66675 11.4792 2.76258 11.2875 2.95425C11.0958 3.14592 11 3.38342 11 3.66675C11 3.95008 11.0958 4.18758 11.2875 4.37925C11.4792 4.57092 11.7167 4.66675 12 4.66675Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPaste);
export default ForwardRef;
